export default __webpack_public_path__ + "static/media/ic-hours-large.f98ce3d9.svg";